import { useEffect } from 'react';
import { Tooltip, theme } from 'antd';
import { useMakeLogo } from '../../../../features/catalogue/viewmodels/useMakeLogo';
import { MakeLogoTile } from '../../../../features/catalogue/views/MakeLogoTile';

export function VehicleLogoBadge({ brandName, logoUrl, logo, height = 14, textColor, hideFallback = false, onAvailabilityChange }) {
  const { token } = theme.useToken();
  const { url, fail } = useMakeLogo({ make_logo_url: logoUrl, logo });
  useEffect(() => { onAvailabilityChange?.(Boolean(url)); }, [url, onAvailabilityChange]);
  if (!brandName || (!url && hideFallback)) return null;
  return url ? <MakeLogoTile src={url} name={brandName} height={height} tone={logo?.tone} onError={fail} />
    : <Tooltip title={brandName}><span style={{ fontSize: 10, fontWeight: 700, color: textColor || token.colorTextSecondary, flexShrink: 0 }}>{brandName}</span></Tooltip>;
}
